module.exports = __webpack_public_path__ + "static/media/Liikuntaohjeet_DM1_190613.1a01787a.pdf";